import type { UseEbmProposalsEditorReturn } from 'hooks/useEbmProposalsEditor';
import { createEditorContext } from './createEditorContext';

const { Provider, useEditorContext } =
  createEditorContext<UseEbmProposalsEditorReturn>('EbmProposalsEditor');

export const EbmProposalsEditorProvider = Provider;
export const useEbmProposalsEditorContext = useEditorContext;
